import { SupportedMessageFormats } from "../../../Contracts";
import { ResponseFormatter } from "../../../Common";
export function SDQResponseFormatter(payload) {
    const p = JSON.parse(payload.data);
    if (p.result === "Unsubscribed") {
        return {
            id: "Unsubscribed",
            result: {}
        };
    }
    return ResponseFormatter(SupportedMessageFormats["jsonrpc2.0"], p);
}
//# sourceMappingURL=SDQResponseFormatter.js.map